// import placeHolder from "assets/images/compressed/hatt.png";
import placeHolder from "assets/images/video_gif.gif";
import animationVideo from "assets/images/animation.mp4";
// import Counter from "../utils/Counter";

const About = () => {
  return (
    <section id="about" className="container row">
      <div className="description" data-aos="fade-up">



        <p> <strong>The Cooties </strong> is a unique collection of <strong> 4,444 </strong> 
        generative Non-Fungible Tokens with many different styles. Each artwork is 
        original and the objective was to make each Cootie unique in order to prioritize
         quality above quantity. 
         <strong> The Cooties </strong>  Ecosystem also features Animated, 2D and 3D NFT’s With more being added.  
        </p>
        <br />


          
        {/* <div className="launch-date" data-aos="fade-down">
          <h3>DEC 13 at 5PM EST</h3>
        </div>
        <div className="hero-counter" data-aos="fade-up">
        <Counter time="Dec 13, 2021 15:00:00" />
        </div> */}
      </div>
      <div className="about-right" data-aos="fade-down">
        {/* <img  className="about-img" src={placeHolder} alt="" /> */}
        <video poster={placeHolder} autoPlay muted loop>
          <source src={animationVideo}/>
        </video>
      </div>
    </section>
  );
};

export default About;
